import { render } from "./LiveExpiryBadgeState.vue?vue&type=template&id=35479baa"
import script from "./LiveExpiryBadgeState.vue?vue&type=script&lang=js"
export * from "./LiveExpiryBadgeState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__